

export const banner = String.raw`
 %c ___
 | _ \_ _ __ ___
 |  _/ '_/ _(_-<_
 |_| |_| \__/__(_)

%cBusiness automation service is running successfully!👍🏼

Developed with ❤️ using Processious Automation Platform
by ManiarTech® http://maniartech.com

`

export const printBanner = (short:boolean = true) => {
  console.log(banner, "color:green", "color:orange")
}